import { warehouseApis } from '@apis/dashboard/warehouseApis';
import { useMutation } from '@hooks/useMutation';
import { WarehouseBase } from '@models/Warehouse';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePutWarehouse = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: WarehouseBase) => {
      const response = await warehouseApis.put('/dashboard/warehouse/{id}/', {
        path: { id },
        body,
      });
      if (response[500]) {
        throw new FormError('PutWarehouse', response[500]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/dashboard/warehouse/`]);
      },
    },
  );
};
